import Style from "./EnterpriseInfoStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../../shared/Bootstrap/TwoButtonsModal";
import api from "../../../services/api";

import { FaTrashAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import PageTitle from "../../../components/PageTitle";

export default function EnterpriseInfo(props) {

  const [pages, setPages] = useState([] as any);
  const [textConfigs, setTextConfigs] = useState([] as any);
  const [deletingPage, setDeletingPage] = useState(false);
  const [pageToDelete, setPageToDelete] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const enterpriseId = props.match.params.enterpriseId;

  useEffect(() => {
    LoadInfos();
    LoadTextConfigs();
  }, []);


  function CreatePage() {
    GoToPageDetails(-1);
  }

  function GoToPageDetails(pageId) {
    props.history.push(`/enterprises/${enterpriseId}/info/${pageId}`);
  }

  async function DeletePage() {
    setDeletingPage(true);
    setLoading(true);
    try {
      const result = await api.delete(`/enterprises/info/${pageToDelete.id}`);
      if (result.data.success) {
        setSuccessMessage("Página deletada com sucesso!");
        setErrorMessage("");
        setLoading(false);
      } else {
        setSuccessMessage("");
        setErrorMessage("Problema ao deletar a tarefa!");
        setLoading(false);

      }
      await LoadInfos();
      setDeletingPage(false);
      ClosePopupDeletingPage();
    }
    catch (error) {
      setDeletingPage(false);
      ClosePopupDeletingPage();
      setLoading(false);
      setSuccessMessage("");
      setErrorMessage("Problema ao deletar a tarefa: " + error);
    }

  }

  async function LoadInfos() {
    setLoading(true);
    try {

      const result = await api.get(`/enterprises/${enterpriseId}/info`);
      if (!result.data.success) {
        console.error("Erro: ", result.data);
        setErrorMessage("Não foi possível consultar informações!");
        setSuccessMessage("");
        setLoading(false);
        return;
      }

      setErrorMessage("");
      const infos = result.data.enterpriseInfo;
      setPages(infos);
    }
    catch (error) {
      console.error("Erro consultando dados das informações: ", error);
      setErrorMessage("Não foi possível carregar as páginas");
    }

    finally {
      setLoading(false);
    }
  }

  async function LoadTextConfigs() {
    setLoading(true);
    try {

      const result = await api.get(`/enterprises/${enterpriseId}/textConfigs`);
      if (!result.data.success) {
        console.error("Erro: ", result.data);
        setErrorMessage("Não foi possível consultar configurações de texto!");
        setSuccessMessage("");
        setLoading(false);
        return;
      }

      setErrorMessage("");
      const text = result.data.enterpriseTextConfigs;
      setTextConfigs(text);
    }
    catch (error) {
      console.error("Erro consultando configurações de texto: ", error);
      setErrorMessage("Não foi possível carregar as páginas");
    }

    finally {
      setLoading(false);
    }
  }

  function GoToPage(pageId: number) {
    props.history.push(`/enterprises/${enterpriseId}/info/${pageId}`);
  }

  function GoToTextConfigPage(pageId: number) {
    props.history.push(`/enterprises/${enterpriseId}/textConfigs/${pageId}`);
  }

  function ClosePopupDeletingPage() {
    setPageToDelete({});
  }

  return (
    <Style>
      <PageTitle title="Informações do empreendimento" />
      <TwoButtonsModal
        show={pageToDelete.id != null}
        onHide={ClosePopupDeletingPage}
        loading={deletingPage}
        title="Deleção de tarefa!"
        body={`Você está tentando deletar a página "${pageToDelete.page}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingPage}
        secondaryDisabled={deletingPage}
        primaryText="Deletar"
        primaryOnClick={DeletePage}
        primaryDisabled={deletingPage}
      />
      <button onClick={() => props.history.goBack()} className=" btn-secondary">Voltar</button>
      <Spinner spinning={loading} />
      <section className="table-title">
        <h1>Páginas de informação do empreendimento</h1>
        <button onClick={CreatePage}>Adicionar página</button>
      </section>
      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}

      <table className="table table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Página</th>
            <th>Titulo</th>
            <th>Descrição</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {pages.length > 0 && pages.map(page => {
            return (
              <tr key={page.id} >
                <td onClick={() => GoToPage(page.id)} className="clickable">{page.page}</td>
                <td onClick={() => GoToPage(page.id)} className="clickable">{page.title}</td>
                <td onClick={() => GoToPage(page.id)} className="clickable">{page.description}</td>
                <td>
                  <div className="action" onClick={() => setPageToDelete(page)}>
                    <FaTrashAlt className="icon" />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <section className="table-title">
        <h1>Outras Paginas do empreendimento</h1>
      </section>
      
      <table className="table table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Página</th>
            <th>Titulo</th>
            <th>Descrição</th>
          </tr>
        </thead>
        {textConfigs.length > 0 &&<tbody>
              <tr>
                <td>Informações de Contato:</td>
                <td onClick={() => GoToTextConfigPage(textConfigs[0].id)} className="clickable">{textConfigs[0].contactTitle}</td>
                <td onClick={() => GoToTextConfigPage(textConfigs[0].id)} className="clickable">{textConfigs[0].contactDescription}</td>
              </tr>
              <tr>
                <td>Notas Gerais</td>
                <td onClick={() => GoToTextConfigPage(textConfigs[0].id)} className="clickable">{textConfigs[0].notesTitle}</td>
                <td onClick={() => GoToTextConfigPage(textConfigs[0].id)} className="clickable">{textConfigs[0].notesDescription}</td>
              </tr>
        </tbody>}
      </table>
    </Style >

  )
}